import { styled, ButtonIcon as ButtonIconHouston } from 'shared/Houston';

export const RowGrid = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.xxxs};
  border: 1px solid ${({ theme }) => theme.neutralColor.high.medium};
  border-radius: ${({ theme }) => theme.border.radius.xs};
  background: ${({ theme }) => theme.neutralColor.high.pure};
`;

export const ItemStatusContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.stack.xxxs};
`;

export const ButtonIcon = styled(ButtonIconHouston)`
  padding: 0;
`;
